import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {GraphProvider} from './GraphContext'
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from "@azure/msal-react";
import msalConfig from './Auth_config';
import { ReactProvider, ResetProvider} from './ResetContext'
const msalInstance =new PublicClientApplication(msalConfig)



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MsalProvider instance={msalInstance}>
  <React.StrictMode>
    <ResetProvider>
    <GraphProvider>
    <App />
    </GraphProvider>
    </ResetProvider>
  </React.StrictMode>
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
